import { LocationData } from '../types';

export const locationData: LocationData[] = [
  {
    name: "Morristown",
    spend: 100071.63,
    clients: 75,
    breakeven: {
      current: 386.65,
      better: 425.13,
      increments: {
        "0.05": 446.39,
        "0.10": 467.65,
        "0.15": 488.90,
        "0.20": 510.16,
        "0.25": 531.41
      }
    }
  },
  {
    name: "Bean Station",
    spend: 24350.91,
    clients: 75,
    breakeven: {
      current: 136.58,
      better: 152.10,
      increments: {
        "0.05": 159.71,
        "0.10": 167.32,
        "0.15": 174.92,
        "0.20": 182.53,
        "0.25": 190.13
      }
    }
  },
  {
    name: "New Tazewell",
    spend: 25431.52,
    clients: 75,
    breakeven: {
      current: 139.90,
      better: 155.43,
      increments: {
        "0.05": 163.20,
        "0.10": 170.97,
        "0.15": 178.74,
        "0.20": 186.52,
        "0.25": 194.29
      }
    }
  },
  {
    name: "Maryville",
    spend: 42791.69,
    clients: 65,
    breakeven: {
      current: 328.40,
      better: 361.24,
      increments: {
        "0.05": 379.30,
        "0.10": 397.36,
        "0.15": 415.42,
        "0.20": 433.48,
        "0.25": 451.54
      }
    }
  },
  {
    name: "Newport",
    spend: 23379.27,
    clients: 45,
    breakeven: {
      current: 259.77,
      better: 285.75,
      increments: {
        "0.05": 300.04,
        "0.10": 314.33,
        "0.15": 328.62,
        "0.20": 342.91,
        "0.25": 357.20
      }
    }
  },
  {
    name: "Rogersville",
    spend: 48092.18,
    clients: 55,
    breakeven: {
      current: 437.20,
      better: 480.92,
      increments: {
        "0.05": 504.97,
        "0.10": 529.02,
        "0.15": 553.07,
        "0.20": 577.12,
        "0.25": 601.17
      }
    }
  },
  {
    name: "Jefferson City",
    spend: 61753.47,
    clients: 70,
    breakeven: {
      current: 441.10,
      better: 485.21,
      increments: {
        "0.05": 509.47,
        "0.10": 533.73,
        "0.15": 557.99,
        "0.20": 582.25,
        "0.25": 606.51
      }
    }
  }
];

export const companyBreakeven = {
  perVisit: 100,
  increments: {
    "0.05": 1418.37,
    "0.10": 1485.91,
    "0.15": 1553.45,
    "0.20": 1620.99,
    "0.25": 1688.53
  },
  current: 1350.83
};